export const PalettePrimaryBase = "#0088CE";
export const PalettePrimaryContrastText = "#FFFFFF";
export const PaletteSecondaryBase = "#313131";
export const PaletteSecondaryContrastText = "#FFFFFF";
export const PaletteTertiaryBase = "#0088CE";
export const PaletteTertiaryContrastText = "#FFFFFF";
export const PaletteAccentBase = "#69BE28";
export const PaletteAccentContrastText = "#FFFFFF";
export const PaletteTextBody = "#313131";
export const PaletteTextLight = "#6C6f70";
export const PaletteTextHeading = "#313131";
export const PaletteTextPrice = "#0088CE";
export const PaletteTextLink = "#0088CE";
export const PaletteBackgroundBody = "#F2F2F2";
export const PaletteBackgroundContent = "#FFFFFF";
export const PaletteBackgroundOffset = "#F2F2F2";
export const PaletteDivider = "#F2F2F2";
export const PaletteBorder = "#D6D6D6";
export const PaletteStarRating = "#FFB700";
export const TypographyBaseFontSize = 16;
export const TypographyBaseLineHeight = 1.5;
export const TypographyFamilyBodyFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyBodyFontWeightDefault = 400;
export const TypographyFamilyBodyFontWeightSemiBold = 600;
export const TypographyFamilyBodyFontWeightBold = 700;
export const TypographyFamilyCaptionFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyCaptionFontWeightDefault = 400;
export const TypographyFamilyCaptionFontWeightSemiBold = 600;
export const TypographyFamilyCaptionFontWeightBold = 700;
export const TypographyFamilyHeadingFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyHeadingFontWeightDefault = 700;
export const TypographyFamilyHeadingFontWeightBold = 700;
export const TypographyFamilyHeroFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyHeroFontWeightDefault = 700;
export const TypographyFamilyHeroTextTransform = "uppercase";
export const TypographyFamilyPriceFontFamily = "'Open Sans', arial, sans-serif";
export const TypographyFamilyPriceFontWeightDefault = 700;
export const TypographyFamilyPriceTextTransform = "uppercase";
